var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "siren-searchbar-loading" }, [
    _c(
      "div",
      { staticClass: "siren-searchbar-loading__header" },
      [
        _c("CompassSkeleton", {
          staticClass: "siren-searchbar-loading__icon",
          attrs: { variant: "square" }
        }),
        _vm._v(" "),
        _c("CompassSkeleton", {
          staticClass: "siren-searchbar-loading__title",
          attrs: { size: "large" }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("CompassSkeleton", {
          staticClass: "siren-searchbar-loading__siret"
        }),
        _vm._v(" "),
        _c("CompassSkeleton", {
          staticClass: "siren-searchbar-loading__address"
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }